export default "__VITE_ASSET__1d6qd1b7__"